import ArtifactGroupType from "@/roc/museum/base/ArtifactGroupType";

const DrakesFirearm = {
  id: '94',
  name: 'Drakes Firearm',
  icon: 'DrakesFirearm',
  groupIcon: 'LegendsOfTheHighSeas',
  type: ArtifactGroupType.LEGENDS_OF_THE_HIGH_SEAS,
  power: 25,
  gameId: 'DrakesFirearm'
};

export default DrakesFirearm;
